module.exports = __webpack_public_path__ + "img/乐途_01.767030c5.jpg";